// language selector

$('.language-selector-wrapper').on( "click", function() {
    $('#language-selection').modal('show');
});

$('#language-selection .close-modal').on( "click", function() {
    $('#language-selection').modal('hide');
});

// animation on scroll

const anim = document.getElementsByClassName('animated');
if(window.screen.width >= 576){
    var animOffset = 200;
}else{
    var animOffset = 100;
}

if(anim){

    document.addEventListener("scroll", (e)=>{
        for (let i = 0; i < anim.length; i++){
            if( window.innerHeight - anim[i].getBoundingClientRect().top - animOffset > 0 ){
                anim[i].classList.add(anim[i].dataset.animation);
            }else{
                anim[i].classList.remove(anim[i].dataset.animation);
            }
        }
    } );

    document.addEventListener('DOMContentLoaded', function() {
        for (let i = 0; i < anim.length; i++){
            if( window.innerHeight - anim[i].getBoundingClientRect().top - animOffset > 0 ){
                anim[i].classList.add(anim[i].dataset.animation);
            }else{
                anim[i].classList.remove(anim[i].dataset.animation);
            }
        }
    });
    
}



// header support button 
const headerSupportWrp = document.querySelector('.header-support-button-wrp');
const headerSupportButton = document.getElementById('header-support-button-toggle');

if( headerSupportWrp != null ){
  
  headerSupportButton.addEventListener('click', function(){
    headerSupportWrp.classList.toggle('active');
  });
  
  document.body.addEventListener('click', function(e) {
    if(!e.target.closest('.header-support-dropdown')){
      headerSupportWrp.classList.remove('active');
    }
  }, true); 
  
}



// scroll top button
document.addEventListener("DOMContentLoaded", function() {
  const scrollBtn = document.getElementById("id-scroll-top-button");

  function checkScroll() {
    const scrollY = window.scrollY || document.documentElement.scrollTop;
    const pageHeight = document.documentElement.scrollHeight;
    const windowHeight = window.innerHeight;
    // set threshold to be bigger than window height but not smaller than minimum of 33% of page height or 1400px
    const scrollThreshold = Math.max(windowHeight, Math.min(pageHeight * 0.33, 1400));

    if (scrollY > scrollThreshold) {
      scrollBtn.classList.add("scroll-top-button-visible");
    } else {
      scrollBtn.classList.remove("scroll-top-button-visible");
    }
  }

  window.addEventListener("scroll", checkScroll);
  window.addEventListener("resize", checkScroll);

  scrollBtn.addEventListener("click", function() {
    window.scrollTo({ top: 0, behavior: "smooth" });
  });

  checkScroll();
});



const testDaysPopUpToggle = document.querySelectorAll('.test-days-pop-up-toggle')
if(testDaysPopUpToggle){
    testDaysPopUpToggle.forEach((item) => {
        item.addEventListener('click', (e) => {
            document.querySelectorAll('.test-days-pop-up.open').forEach((item) => {
                item.classList.remove('open')
            })
            item.closest('li').querySelector('.test-days-pop-up').classList.add('open')
        })
    })
    document.addEventListener('click', (e) => {
        if(!e.target.closest('.test-days-pop-up-toggle')){
            document.querySelectorAll('.test-days-pop-up.open').forEach((item) => {
                item.classList.remove('open')
            })
        }
    })
}


const buttonContinueReading = document.querySelectorAll('.button-continue-reading')
if(buttonContinueReading){
    buttonContinueReading.forEach((button) => {
        button.addEventListener('click', (e) => {
            let wrp = e.target.closest('.continue-reading-wrp')
            if(wrp){
                wrp.classList.toggle('expanded')
            }
        })
    })
}


document.addEventListener('DOMContentLoaded', deliveryEstimate() );

function deliveryEstimate(){
  const estDateContainer = document.querySelector('.est-date');
  const estDateContainerAll = document.querySelectorAll('.est-date');
  if(estDateContainer){
    
    var lngCode = estDateContainer.dataset.region;
    var curLanguage = estDateContainer.dataset.language;
    if( curLanguage == ''){
        curLanguage = 'fr-fr';
    }
    if( curLanguage == 'en-int'){
        curLanguage = 'en-en';
    }
    var date = new Date();
    var hour = date.getHours();

    var duration = 14;
    
    if( lngCode == 'fr' && hour < 12 ){
        duration = 2;
    }
    if( lngCode == 'fr' && hour >= 12 ){
        duration = 3;
    }
    
    if( lngCode == 'be' && hour < 12 ){
        duration = 2;
    }
    if( lngCode == 'be' && hour >= 12 ){
        duration = 3;
    }

    if( lngCode == 'nl' && hour < 12 ){
        duration = 2;
    }
    if( lngCode == 'nl' && hour >= 12 ){
        duration = 3;
    }

    if( lngCode == 'ch' && hour < 12 ){
        duration = 1;
    }
    if( lngCode == 'ch' && hour >= 12 ){
        duration = 2;
    }

    if( lngCode == 'de' && hour < 12 ){
        duration = 3;
    }
    if( lngCode == 'de' && hour >= 12 ){
        duration = 3;
    }
    if( lngCode == 'us' ){
        duration = 2;
    }
    if( lngCode == 'eu' ){
        duration = 4;
    }
    if( lngCode == 'gb' || lngCode == 'no' || lngCode == 'pl' || lngCode == 'it' || lngCode == 'da' || lngCode == 'fi' || lngCode == 'se' || lngCode == 'cz' || lngCode == 'ua' || lngCode == 'es' ){
        duration = 4;
    }

    if( lngCode == 'world' ){
        duration = 14;
    }
    
    var deliveryDate = addBusinessDays(date, duration);
    var deliveryDateText = deliveryDate.getDate() + '&nbsp;' +  getLocalizedMonth(deliveryDate, curLanguage);

    estDateContainerAll.forEach((item) => {
        item.innerHTML = deliveryDateText;
    })
    //estDateContainer.innerHTML = deliveryDate.getDate() + '&nbsp;' +  new Intl.DateTimeFormat( curLanguage, { month: "long" }).format(deliveryDate);
    
  }
}

function getLocalizedMonth(deliveryDate, locale) {
    const monthMaps = {
      fr: ["janv.", "févr.", "mars", "avr.", "mai", "juin", "juill.", "août", "sept.", "oct.", "nov.", "déc."],
      en: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
      de: ["Jan.", "Feb.", "März", "Apr.", "Mai", "Juni", "Juli", "Aug.", "Sept.", "Okt.", "Nov.", "Dez."]
    };
  
    const date = new Date(deliveryDate);
    const monthIndex = date.getMonth(); // 0-11
    let lang = locale.slice(0, 2); // "fr", "en", "de"
  
    if (!monthMaps.hasOwnProperty(lang)) {
      lang = 'fr';
    }
  
    return monthMaps[lang][monthIndex];
}

function addBusinessDays(d,n) {
  d = new Date(d.getTime());
  var day = d.getDay();
  d.setDate(d.getDate() + n + (day === 6 ? 2 : +!day) + (Math.floor((n - 1 + (day % 6 || 1)) / 5) * 2));
  return d;
}


document.addEventListener('DOMContentLoaded', function() {
    let anchor = getAnchor();
    let modal = document.getElementById('compare-products');
    if(anchor == 'compare'){
        document.body.classList.add('noscroll');
        modal.classList.add('open');
    }
});

function getAnchor() {
    return (document.URL.split('#').length > 1) ? document.URL.split('#')[1] : null;
}


const inViewport = (elem, el_offset = 0) => {
    let allElements = document.getElementsByClassName(elem);
    let windowHeight = window.innerHeight;
    const elems = () => {
        for (let i = 0; i < allElements.length; i++) { 
            let viewportOffset = allElements[i].getBoundingClientRect(); 
            let top = viewportOffset.top + el_offset;
            if(top < windowHeight){ 
                allElements[i].classList.add('in-viewport');
            } else{
                allElements[i].classList.remove('in-viewport');
            }
        }
    }
    elems();
    window.addEventListener('scroll', elems);
}


const hints = document.querySelectorAll('.info-hint');

hints.forEach((item) => {
    item.addEventListener('click', (e) => {
        closeAllOpenDialogs();
        let dialog = item.querySelector('dialog');
        dialog.setAttribute('open', '1');
    });
});

document.addEventListener('click', e => {
    if( !e.target.closest('.info-hint')  ){ 
        closeAllOpenDialogs();
    }
});

function closeAllOpenDialogs(){
    const openDialogs = document.querySelectorAll('dialog[open]');
    openDialogs.forEach((item) => {
        item.removeAttribute('open');
    });
}


$(function () {
    const e = $('[data-show-more-role="wrapper"]');
    if (e.length < 1) return;
    const t = ({ $listItems: e }) =>
            e.filter((e, t) => !$(t).hasClass("show")),
        n = ({ $listItems: e }) =>
            e.filter((e, t) => $(t).is(":visible"));
    e.each(function () {
        const e = $(this),
            i = e.data("show-more-default-visible-items"),
            r = e.find('[data-show-more-role="list-item"]'),
            o = e.find('[data-show-more-role="trigger-btn"]');
        i && r.length >= i && r.slice(i).hide(),
            (!i || r.length <= i) &&
                e.addClass("all-items-are-shown");
        const s = n({ $listItems: r });
        s.each(function (e) {
            const t = $(this);
            t.addClass("show"),
                s.length === e + 1 &&
                    t.addClass("last-visible-item");
        }),
            o.on("click", function (i) {
                i.preventDefault(),
                    t({ $listItems: r })
                        .slice(0, 3)
                        .show(0, function () {
                            $(this).addClass("show"),
                                t({ $listItems: r }).length ||
                                    e.addClass(
                                        "all-items-are-shown"
                                    );
                        });
                const o = n({ $listItems: r });
                o.removeClass("last-visible-item"),
                    $(o[o.length - 1]).addClass(
                        "last-visible-item"
                    );
            });
    });
});